import { render, staticRenderFns } from "./ExperimentReportTest.vue?vue&type=template&id=5f89f6f6&scoped=true&"
import script from "./ExperimentReportTest.vue?vue&type=script&lang=js&"
export * from "./ExperimentReportTest.vue?vue&type=script&lang=js&"
import style0 from "./ExperimentReportTest.vue?vue&type=style&index=0&id=5f89f6f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f89f6f6",
  null
  
)

export default component.exports